import * as XLSX from 'xlsx'

function dateValue(value) {
  if (typeof value?.toDate === 'function') return value.toDate()
  if (value instanceof Date) return value
  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }
  return null
}

function fileName(storagePath) {
  const lastPart = String(storagePath || '').split('/').pop() || ''
  try {
    return decodeURIComponent(lastPart)
  } catch {
    return lastPart
  }
}

function safeFilename(value) {
  return String(value || 'recordings').replace(/[^a-z0-9_-]/gi, '_')
}

function hasEyeTracking(response) {
  const tracking = response.eye_tracking || {}
  return Object.keys(tracking.recordings || {}).length > 0 || Object.keys(tracking.ad_exposures || {}).length > 0
}

export function exportRecordingReport({ responses, surveyCode, surveyName, recordingsForResponse, activeLabel, passiveLabel }) {
  const rows = responses.flatMap((response) => {
    const recordings = recordingsForResponse(response)
    const common = {
      'Test adı': surveyName,
      'Test kodu': surveyCode,
      Katılımcı: response.bfrid || response.participant_id || '',
      'Katılımcı adı': response.respondent_name || '',
      'Yanıt ID': response.response_id || response.sourceResponseId || '',
      'Rapor durumu': response.reportActive === false ? passiveLabel : activeLabel,
      'Anket durumu': response.status || '',
      Dil: response.language || '',
      'Tamamlanma / güncellenme zamanı': dateValue(response.completed_at || response.updated_at) || '',
      'Göz takibi kaydı': hasEyeTracking(response) ? 'Var' : 'Yok',
    }
    const fileRows = recordings.length ? recordings : [null]
    return fileRows.map((recording) => ({
      ...common,
      'Dosya adı': recording ? fileName(recording.storagePath) : '',
      'Kayıt açıklaması': recording?.label || '',
      'Kayıt ID': recording?.id || '',
      'Dosya yolu': recording?.storagePath || '',
      'İçerik türü': recording?.contentType || '',
    }))
  })

  const worksheet = XLSX.utils.json_to_sheet(rows)
  worksheet['!cols'] = [28, 28, 20, 22, 28, 16, 18, 10, 25, 18, 36, 34, 26, 55, 18]
    .map((wch) => ({ wch }))
  if (rows.length) {
    worksheet['!autofilter'] = {
      ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: Object.keys(rows[0]).length - 1, r: rows.length } }),
    }
  }

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Kayıtlar')
  XLSX.writeFile(workbook, `${safeFilename(surveyCode)}-kayit-raporu.xlsx`, { cellDates: true })
}
